import { CodeBulkUploadType } from 'utils/apiList/bulkUploadV2'

export const getBulkUploadCodeByCampaignType = (value: string) => {
  let codeBulkUpload: CodeBulkUploadType = ''
  if (value === 'BMSM') codeBulkUpload = 'INVENTORY_DISCOUNT_BMSM'
  if (value === 'DISCOUNT_CAMPAIGN' || value === 'OPTIC_CAMPAIGN')
    codeBulkUpload = 'INVENTORY_DISCOUNT_CAMPAIGN'

  return codeBulkUpload
}
